import { useEffect, useState } from 'react';
import { Droppable, DroppableProps } from 'react-beautiful-dnd';

/*
  Este componente é um wrapper para o Droppable do react-beautiful-dnd
  que resolve o problema de compatibilidade com o StrictMode do React.
  
  Problema original: https://github.com/atlassian/react-beautiful-dnd/issues/2399
*/
export const StrictModeDroppable = ({ children, ...props }: DroppableProps) => {
  const [enabled, setEnabled] = useState(false);
  
  useEffect(() => {
    // Habilita o Droppable após o primeiro render para evitar o problema com o StrictMode
    const animation = requestAnimationFrame(() => setEnabled(true));
    
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);
  
  if (!enabled) {
    return null;
  }
  
  return <Droppable {...props}>{children}</Droppable>;
};

export default StrictModeDroppable; 